import settings from '@/config/settings';

import type {IUser, IUserFilters, IUserShort} from '@/api/types/user';

import useAPIHook from '@/assets/core/assets/hooks/APIHook';

const url = new URL(settings.SERVICES.BACKEND.URL + '/user/list');

export const userListAPI = useAPIHook<
  IUserShort,
  IUser,
  unknown,
  unknown,
  IUserFilters
>(url);
